import {
  PublikovanyTerminListApi,
  PublikovanyTerminListPage as TerminListPageGenerated,
  SortDirectionEnum,
  PublikovanyTerminFilter as PublikovanyTerminFilterGenerated,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import PublikovanyTerminListPage from '../../model/PublikovanyTerminListPage';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import PublikovanyTerminFilter from '../../model/PublikovanyTerminFilter';

const client = new PublikovanyTerminListApi(apiConfiguration(tezauryPrefixPath));

const map = (data: TerminListPageGenerated): PublikovanyTerminListPage => ({
  terminList: data.terminList,
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

const mapFilter = (data: PublikovanyTerminFilter): PublikovanyTerminFilterGenerated => ({
  tezaurusUuid: data?.tezaurus?.uuid,
  hladanyTermin: data.searchTextHladanyTermin,
  doktrinalnyZdroj: data.searchTextDoktrinalnyZdroj,
  legalnyZdroj: data.searchTextLegalnyZdroj,
  pouzitiePredpisPopisList: data.pouzitiePredpisList.map(predpis => predpis.popis),
});

// eslint-disable-next-line import/prefer-default-export
export const fetchPublikovanyTerminPage = async (
  filter: PublikovanyTerminFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<PublikovanyTerminListPage>> => {
  const {
    data,
    status,
  } = await client.getPublikovanyTerminList(
    mapFilter(filter),
    page,
    size,
    sortBy,
    sortDirection,
    options,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
